import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Inbox, Sparkles, FileText, Users } from "lucide-react";

function Stat({ label, value, testid }) {
  return (
    <div className="bg-white border border-[#E5E5E5] p-6" data-testid={testid}>
      <p className="overline text-charcoal/50">{label}</p>
      <p className="font-serif text-4xl text-deep-navy mt-2">{value}</p>
    </div>
  );
}

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [audit, setAudit] = useState([]);

  useEffect(() => {
    api.get("/admin/stats").then(({ data }) => setStats(data)).catch(() => {});
    api.get("/admin/audit").then(({ data }) => setAudit(data.slice(0, 8))).catch(() => {});
  }, []);

  return (
    <div>
      <h1 className="font-serif text-4xl text-deep-navy mb-2">Dashboard</h1>
      <p className="text-charcoal/60 mb-8">Overview of leads and content.</p>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <Stat label="Total leads" value={stats?.leads_total ?? "—"} testid="stat-leads-total" />
        <Stat label="New leads" value={stats?.leads_new ?? "—"} testid="stat-leads-new" />
        <Stat label='"Process" enquiries' value={stats?.leads_process ?? "—"} testid="stat-leads-process" />
        <Stat label="Published insights" value={stats?.insights_published ?? "—"} testid="stat-insights-published" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-8">
        <div className="bg-white border border-[#E5E5E5] p-6">
          <p className="overline text-restrained-blue mb-4">Quick actions</p>
          <div className="space-y-2">
            <Link to="/admin/leads" className="flex items-center gap-3 p-3 border border-[#E5E5E5] hover:bg-off-white transition-colors"><Inbox size={18} className="text-restrained-blue" /> Review leads</Link>
            <Link to="/admin/insights" className="flex items-center gap-3 p-3 border border-[#E5E5E5] hover:bg-off-white transition-colors"><FileText size={18} className="text-restrained-blue" /> Manage Insights ({stats?.insights_drafts ?? 0} drafts)</Link>
            <Link to="/admin/leadership" className="flex items-center gap-3 p-3 border border-[#E5E5E5] hover:bg-off-white transition-colors"><Users size={18} className="text-restrained-blue" /> Leadership profiles</Link>
          </div>
        </div>
        <div className="bg-white border border-[#E5E5E5] p-6">
          <p className="overline text-restrained-blue mb-4">Recent activity</p>
          {audit.length === 0 ? (
            <p className="text-sm text-charcoal/50">No activity yet.</p>
          ) : (
            <ul className="space-y-3">
              {audit.map((a) => (
                <li key={a.id} className="flex justify-between text-sm border-b border-[#E5E5E5] pb-2">
                  <span className="text-charcoal/80"><span className="font-medium">{a.action}</span> · {a.entity}</span>
                  <span className="text-charcoal/40">{new Date(a.timestamp).toLocaleDateString()}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
